import { taskRoutes } from "./task-routes";

export default (router: any) => {
  taskRoutes.forEach((route: any) => {
    router.addRoute(route);
  });
};
